
  import { useState} from "react";
import {
  TransformWrapper,
  TransformComponent,
} from "react-zoom-pan-pinch";

export default function PhotoCard({ image }) {
  const [fullscreen, setFullscreen] = useState(false);
  const [loading, setLoading] = useState(true);


  return (
    <>
      {/* Normal Photo */}
      <div className="relative w-full h-full bg-black overflow-hidden rounded-2xl">
        {loading && (
          <div className="absolute inset-0 z-30 flex flex-col items-center justify-center bg-black">
            <div className="w-10 h-10 border-4 border-white border-t-transparent rounded-full animate-spin" />
            <p className="mt-3 text-white font-medium">
              🏔️ Loading summit...
            </p>
          </div>
        )}
      <button
  onClick={() => setFullscreen(true)}
  className="
    absolute
    top-3
    right-3
    z-20
    w-12
    h-12
    rounded-full
    bg-black/60
    hover:bg-black/80
    text-white
    text-xl
    backdrop-blur
  "
>
⛶
</button>

        <TransformWrapper
          initialScale={1}
          minScale={1}
          maxScale={5}
          wheel={{ disabled: false }}
          centerOnInit={false}
          onLoad={() => setLoading(false)}
        >
          <TransformComponent
            wrapperClass="w-full h-full"
            contentClass="w-full h-full"
          >
            <img src={image} onLoad={() => setLoading(false)} className="w-full h-full object-cover object-bottom" />
          </TransformComponent>
        </TransformWrapper>
      </div>

      {/* Fullscreen Modal */}
      {fullscreen && (
  <div className="fixed inset-0 z-[9999] bg-black"
  style={{ height: "100dvh" }}>
    <button
      onClick={() => setFullscreen(false)}
      className="
        absolute
        top-4
        right-4
        z-[10000]
        bg-white/90
        text-black
        px-4
        py-2
        rounded-xl
        font-bold
      "
    >
      ✕
    </button>

    <TransformWrapper
      initialScale={1}
      minScale={1}
      maxScale={8}
      centerOnInit
      centerZoomedOut
      pinch={{ step: 5 }}
    >
      <TransformComponent
        wrapperClass="w-screen h-screen"
        contentClass="w-screen h-screen flex items-center justify-center"
      >
        <img src={image}
          alt="Munro"
          className="
            max-w-screen
            max-h-screen
            object-contain
          "
          draggable={false}
        />
      </TransformComponent>
    </TransformWrapper>
  </div>
)}
    </>
  );
}


